var _circle, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 83,
    viewBox: "0 0 83 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41.5,
    cy: 41.5,
    r: 40.4,
    fill: "none",
    stroke: "#00703E",
    strokeWidth: 2.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.5 36.624C64.5 33.9015 62.6775 30.414 60.45 28.8615L47 18.4996C43.85 16.2946 40.705 11.6088 36 16.9996L23.1675 28.839C21.1425 30.414 19.5 33.7665 19.5 36.309V52.9815C19.5 58.2015 23.7525 62.4765 28.9725 62.4765H55.0275C60.2475 62.4765 64.5 58.2015 64.5 53.004V46.029",
    stroke: "#00703E",
    strokeWidth: 2.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 47.5L39.075 42.9258L31.875 50.1258",
    stroke: "#00703E",
    strokeWidth: 2.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M52.125 38.875L48.7275 42.2725L43.5 47",
    stroke: "#00703E",
    strokeWidth: 2.79,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M47.625 38.875H52.125V43.375",
    stroke: "#00703E",
    strokeWidth: 2.33,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/project.6ebc2dc4f4eeb91a98a06c8e30fd298e.svg";
export { ForwardRef as ReactComponent };